import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { Location } from "@/types/Location";
import {
  DrugListResultsProps,
  DrugPricesListResultsProps,
  MemberSelectedDrugConfiguration,
  MemberSelectedDrug,
} from "capitalrx-components-2.0";

export const getDrugApi = createApi({
  reducerPath: "drugListReducer",
  baseQuery: fetchBaseQuery({ baseUrl: site.baseUrl }),
  endpoints: (builder) => ({
    getDrugList: builder.query<DrugListResultsProps, { search: string }>({
      query: (payload) => {
        return {
          url: "/drug/list",
          method: "POST",
          body: payload,
        };
      },
    }),
    getDrugPricesList: builder.query<DrugPricesListResultsProps, MemberSelectedDrugConfiguration>({
      query: (payload) => {
        return {
          url: "/drug/prices/list",
          method: "POST",
          body: payload,
        };
      },
    }),
    getDrugDetails: builder.query<MemberSelectedDrug, { drug_id: number }>({
      query: (payload) => {
        return {
          url: "/drug/get",
          method: "POST",
          body: payload,
        };
      },
    }),
    getUserLocation: builder.query<Location, Location>({
      query: (payload) => {
        return {
          url: "/location/geolocate",
          method: "POST",
          body: payload,
        };
      },
    }),
  }),
});

export const { useGetDrugListQuery, useGetDrugDetailsQuery, useGetDrugPricesListQuery, useGetUserLocationQuery } = getDrugApi;
